/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sub2": {
        "nested": {
          "assets": {
            "nested": {
              "PlanText": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PlanTextList": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PlanFeatureText": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "feature": {
                    "type": "squareup.sub2.data.Feature",
                    "id": 2,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FeatureImage": {
                "fields": {
                  "feature": {
                    "type": "squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FeatureText": {
                "fields": {
                  "feature": {
                    "type": "squareup.sub2.data.Feature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FullPagePaywall": {
                "fields": {
                  "header": {
                    "type": "squareup.sub2.assets.PlanFeatureText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": "squareup.sub2.assets.PlanFeatureText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "image": {
                    "type": "squareup.sub2.assets.FeatureImage",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": "squareup.sub2.assets.FeatureText",
                    "id": 7,
                    "rule": "repeated"
                  }
                }
              },
              "Modal": {
                "fields": {
                  "header": {
                    "type": "squareup.sub2.assets.PlanFeatureText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "headerTrialOne": {
                    "type": "squareup.sub2.assets.PlanFeatureText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "headerTrialOther": {
                    "type": "squareup.sub2.assets.PlanFeatureText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": "squareup.sub2.assets.PlanFeatureText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "includes": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "includedFeatures": {
                    "type": "squareup.sub2.assets.PlanTextList",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": "squareup.sub2.assets.FeatureText",
                    "id": 10,
                    "rule": "repeated"
                  }
                }
              },
              "PaywallCard": {
                "fields": {
                  "header": {
                    "type": "squareup.sub2.assets.PlanFeatureText",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paragraph": {
                    "type": "squareup.sub2.assets.PlanFeatureText",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "tryOne": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "tryOther": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "tierShortname": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "tierName": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "planName": {
                    "type": "squareup.sub2.assets.PlanText",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "learnMoreUrl": {
                    "type": "squareup.sub2.assets.FeatureText",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "Downgrade": {
                "fields": {}
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanTextList && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PlanFeatureText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureImage && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FeatureText && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.FullPagePaywall && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Modal && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.PaywallCard && !$root.nested?.squareup?.nested?.sub2?.nested?.assets?.nested?.Downgrade) {
  $root.addJSON(jsonData);
}

/**
 * Text specific to a particular plan.
 *
 * SOURCE PlanText @ squareup/sub2/assets.proto at 11:1
 */
export const PlanText = $root.lookupType('squareup.sub2.assets.PlanText');
fixType(PlanText);
Builder.createAndAttachToType(PlanText);
/**
 * Multi-line text specific to a particular plan.
 *
 * SOURCE PlanTextList @ squareup/sub2/assets.proto at 19:1
 */
export const PlanTextList = $root.lookupType('squareup.sub2.assets.PlanTextList');
fixType(PlanTextList);
Builder.createAndAttachToType(PlanTextList);
/**
 * Text specific to a particular (plan, feature) tuple.
 *
 * SOURCE PlanFeatureText @ squareup/sub2/assets.proto at 27:1
 */
export const PlanFeatureText = $root.lookupType('squareup.sub2.assets.PlanFeatureText');
fixType(PlanFeatureText);
Builder.createAndAttachToType(PlanFeatureText);
/**
 * Image specific to a particular feature.
 *
 * SOURCE FeatureImage @ squareup/sub2/assets.proto at 36:1
 */
export const FeatureImage = $root.lookupType('squareup.sub2.assets.FeatureImage');
fixType(FeatureImage);
Builder.createAndAttachToType(FeatureImage);
/**
 * Text specific to a particular feature.
 *
 * SOURCE FeatureText @ squareup/sub2/assets.proto at 44:1
 */
export const FeatureText = $root.lookupType('squareup.sub2.assets.FeatureText');
fixType(FeatureText);
Builder.createAndAttachToType(FeatureText);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE FullPagePaywall @ squareup/sub2/assets.proto at 52:1
 */
export const FullPagePaywall = $root.lookupType('squareup.sub2.assets.FullPagePaywall');
fixType(FullPagePaywall);
Builder.createAndAttachToType(FullPagePaywall);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE Modal @ squareup/sub2/assets.proto at 65:1
 */
export const Modal = $root.lookupType('squareup.sub2.assets.Modal');
fixType(Modal);
Builder.createAndAttachToType(Modal);
/**
 * See: https://www.figma.com/design/A7VccamBERizA8pkMjB7Q0/Unified-Upsell-Patterns
 *
 * SOURCE PaywallCard @ squareup/sub2/assets.proto at 81:1
 */
export const PaywallCard = $root.lookupType('squareup.sub2.assets.PaywallCard');
fixType(PaywallCard);
Builder.createAndAttachToType(PaywallCard);
/**
 * SOURCE Downgrade @ squareup/sub2/assets.proto at 92:1
 */
export const Downgrade = $root.lookupType('squareup.sub2.assets.Downgrade');
fixType(Downgrade);
Builder.createAndAttachToType(Downgrade);